import { __assign } from "tslib";
import { extractInlineViewPropsFromObject } from './extractPropsFromObject';
import { buildTaskIcon, buildTaskLozenge } from '../utils/task';
export function extractInlineViewPropsFromTask(json) {
    var props = extractInlineViewPropsFromObject(json);
    return __assign(__assign(__assign({}, props), buildTaskLozenge(json)), buildTaskIcon(json));
}
//# sourceMappingURL=extractPropsFromTask.js.map